import React from 'react';
import Header from '../components/Header/Header';
import Navbar from '../components/Navbar/Navbar';
import iisLogo from "../components/assets/societyLogo.jpg"

const AboutIIS = () => {
  return (<>
    <Header />
    <Navbar />
    <div className="px-4">
      <div className="max-w-7xl mx-auto bg-white p-6">
        {/* Header Section */}
        <header className="flex justify-between items-center mb-2">
          <h1 className="text-3xl md:text-4xl text-gray-800 ">Indian Immunology Society (I.I.S.)</h1>
          <img
            src={iisLogo} 
            alt="Indian Immunology Society Logo"
            className="w-32 md:w-40 rounded-full"
          />
        </header>

        {/* Content Section */}
        <section>
          <h2 className="text-2xl md:text-3xl text-gray-800 mb-4">About Us</h2>
          <p className="text-md md:text-lg text-gray-600 mb-4">
            The Indian Immunology Society was established in 1972-73 to develop and expand the subject of immunology through training and research. 
            The purpose is to use immunology to fight the major health challenges in India and promote opportunities for professional growth for researchers 
            at all stages of their careers. Its members collaborate to advance knowledge, address shared interests, and facilitate the exchange of ideas 
            and information amongst scientists working in different research areas of Immunology. These objectives are achieved through scientific meetings and interactions of the society.
          </p>

          <p className="text-md md:text-lg text-gray-600 mb-4">
            The Indian Immunology Society is a group of professors, scientists, and researchers with professional training from all over the world 
            dedicated to advancing immunology and its related disciplines, encouraging the sharing of knowledge and information between researchers, 
            and addressing the potential application of immunologic principles in clinical practice.
          </p>

          <p className="text-md md:text-lg text-gray-600 mb-4">
            For more details: <a href="https://indianimmunologysociety.org/Home" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">click here</a>
          </p>
        </section>
      </div>
    </div>
    </>
  );
}

export default AboutIIS;
